import Page from "../Page";
//Tradutor para async\await 
import "babel-polyfill";

var FieldEditorCube = (function () {
    var fieldsTreeMainTable = '.fieldsTreeMainTable';
    var fieldsTreeCube = '.fieldsTreeCube';
    let fieldsCube;
    let fieldsCubeNode;
    let numberOfCounterField = 0;
    var paramRequest = getRequests();

    let fieldNameAndFieldCubeJson = {
        "_TABS_ctl03": "FieldType",
        "_TABS_ctl05": "IsData",
        "_TABS_ctl07": "FieldType",
        "_TABS_ctl09": "FieldType",
        "CAMPO": "Formula",
        "OCULTARLEGENDA_CHECKBOX": "Hide",
        "DIADASEMANA_CHECKBOX": "ChkFeira",
        "DIA_CHECKBOX": "ChkDia",
        "MES_CHECKBOX": "ChkMes",
        "ANO_CHECKBOX": "ChkAno",
        "TRIMESTRE_CHECKBOX": "ChkTrimestre",
        "SEMESTRE_CHECKBOX": "ChkSemestre",
        "NRSEMANA_CHECKBOX": "ChkNrSemana",
        "HORA_CHECKBOX": "ChkHora",
        "GroupRadioButton_TIPO_0": "FieldType",
        "GroupRadioButton_TIPO_1": "FieldType",
        "GroupRadioButton_TIPO_4": "FieldType",
        "NOMEMACRO": "MacroName",
        "MACRO_CHECKBOX": "MacroOnly",
        "SOMENTESQL_CHECKBOX": "SqlOnly",
        "FUNCAOselect": "AgregateFunc",
        "FORMATONUMEROselect": "Mask",
        "OCULTAR_CHECKBOX": "Hide",
        "EXPRESSAO": "Formula"
    }

    function getRequests() {
        var s1 = location.search.substring(1, location.search.length).split('&'),
            r = {}, s2, i;
        for (i = 0; i < s1.length; i += 1) {
            s2 = s1[i].split('=');
            r[decodeURIComponent(s2[0]).toLowerCase()] = decodeURIComponent(s2[1]);
        }
        return r;
    };


    var getDesktopCubeFieldsRequest = async function (param) {
        var teste = Page.getApplicationPath();
        console.log(teste);
        var request = $.get(Page.getApplicationPath() + `api/desktopcube/getdesktopcubefields?handle=${param.cb}`);
        request.done(function (data) {
            fieldsCube = data;
            fieldsCubeNode = buildCubeData(fieldsCube);
            buildChildrenCubeData();
            initCubeFieldsTree();
        });
        request.fail(function (msg) {
            console.log("Falha na chamada de api/AsyncProcesses" + msg);
        });
    };

    function buildCubeData(data) {
        var json = [];
        var attributes = [];
        data.Fields.forEach(function (item, index) {
            if (item.ParentField == undefined) {
                if (item.Name == 'NUM_REGISTROS') {
                    numberOfCounterField++;
                    item.Name = 'NUM_REGISTROS_' + numberOfCounterField;
                }
                for (const [key, value] of Object.entries(item)) {
                    attributes[key] = value;
                }
                json.push({
                    'id': item.Name,
                    'text': item.Name + ' - ' + item.Caption,
                    'li_attr': attributes,
                    'children': []
                });
                attributes = [];
            }
        });
        return json;
    }

    var buildChildrenCubeData = async function () {
        for (var index = 0; index < fieldsCube.Fields.length; index++) {
            if (fieldsCube.Fields[index].ParentField != undefined) {
                fieldsCubeNode.find(element => element.id == fieldsCube.Fields[index].ParentField).children.push(buildChildrenData(fieldsCube.Fields[index]));
            }
        }
    }

    function buildChildrenData(children) {
        var attributes = [];
        for (const [key, value] of Object.entries(children)) {
            attributes[key] = value;
        }
        var json = {
            'text': children.Name + " - " + children.Caption,
            'li_attr': attributes
        };
        return json;
    }
    var selectTabFillGeneralInputs = function (data) {
        var tab = '';
        switch (data.li_attr.FieldType) {
            case 0:
            case 1:
            case 4:
                tab = (data.li_attr.IsData == "S" ? '05' : '03');
                break;
            case 2:
                tab = '07';
                break;
            case 3:
                tab = '09';
                break;
        }

        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_ctl" + tab).click();
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_NOMECAMPO").attr('readonly', true);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_NOMECAMPO").val(data.li_attr.Name);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_LEGENDA").val(data.li_attr.Caption);
        setTimeout(function () {
            fillFormInputs(data);
        }, 1000);
    }
    var fillFormInputs = function (data) {
        switch (data.li_attr.FieldType) {
            case 0:
            case 1:
            case 4:
                data.li_attr.IsData == "S" ? fillFormData(data) : fillFormDimension(data);
                break;
            case 2:
                fillFormFact(data);
                break;
            case 3:
                fillFormCalculated(data);
                break;
        }
    }

    var updateFieldsCube = function (data) {
        var tab;

        data.li_attr.Name = $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_NOMECAMPO").val();
        data.li_attr.Caption = $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_LEGENDA").val();

        for (var field in fieldNameAndFieldCubeJson) {
            var key;
            var value;

            if (field.includes('TABS_ctl') && !$("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL" + field).is(':checked'))
                continue;

            if (field.includes('TABS_ctl')) {
                tab = parseInt($("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL" + field).val());

                switch (tab) {
                    case 1:
                        tab = '_TABS_1_';
                        break;
                    case 2:
                        tab = '_TABS_2_';
                        break;
                    case 3:
                        tab = '_TABS_3_';
                        break;
                    case 4:
                        tab = '_TABS_4_';
                        break;
                }
            }

            var attributeField = fieldNameAndFieldCubeJson[field];
            key = (field.includes('TABS_ctl') ? field : tab + field);
            value = $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL" + key).val();
            if (key.includes('CHECKBOX') || key == '_TABS_ctl05')
                value = $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL" + key).is(':checked');

            if (key.includes('GroupRadioButton') || (key == '_TABS_ctl07' || key == '_TABS_ctl09')) {
                if ($("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL" + key).is(':checked'))
                    value = $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL" + key).val();
                else
                    value = undefined;
            }

            if (value == undefined)
                continue;

            if ((key.includes('CHECKBOX') || key == '_TABS_ctl05') && value)
                value = 'S';
            else if ((key.includes('CHECKBOX') || key == '_TABS_ctl05') && !value)
                value = 'N';

            if (attributeField == 'FieldType' && key == '_TABS_ctl07' && value == "3")
                value = "2";

            var desc = 0;
            if (attributeField == 'AgregateFunc')
                desc = 1;                

            data.li_attr[attributeField] = (attributeField == 'FieldType' || attributeField == 'AgregateFunc')  ? parseInt(value) - desc : value;
        }
        var objIndex = fieldsCube.Fields.findIndex(fieldInCube => fieldInCube.Name == data.li_attr.id);
        fieldsCube.Fields[objIndex] = data.li_attr;

    }

    var fillFormData = function (data) {
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_CAMPO").val(data.li_attr.Formula);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_OCULTARLEGENDA_CHECKBOX").prop('checked', (data.li_attr.Hide == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_DIADASEMANA_CHECKBOX").prop('checked', (data.li_attr.ChkFeira == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_DIA_CHECKBOX").prop('checked', (data.li_attr.ChkDia == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_MES_CHECKBOX").prop('checked', (data.li_attr.ChkMes == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_ANO_CHECKBOX").prop('checked', (data.li_attr.ChkAno == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_TRIMESTRE_CHECKBOX").prop('checked', (data.li_attr.ChkTrimestre == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_SEMESTRE_CHECKBOX").prop('checked', (data.li_attr.ChkSemestre == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_NRSEMANA_CHECKBOX").prop('checked', (data.li_attr.ChkNrSemana == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_HORA_CHECKBOX").prop('checked', (data.li_attr.ChkHora == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_2_GroupRadioButton_TIPO_" + data.li_attr.FieldType).click();
    }

    var fillFormDimension = function (data) {
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_1_CAMPO").val(data.li_attr.Formula);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_1_NOMEMACRO").val(data.li_attr.MacroName);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_1_MACRO_CHECKBOX").prop('checked', (data.li_attr.MacroOnly == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_1_SOMENTESQL_CHECKBOX").prop('checked', (data.li_attr.SqlOnly == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_1_GroupRadioButton_TIPO_" + data.li_attr.FieldType).click();
    }

    var fillFormFact = function (data) {
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_3_CAMPO").val(data.li_attr.Formula);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_3_FUNCAOselect").val(parseInt(data.li_attr.AgregateFunc) + 1);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_3_FORMATONUMEROselect").val(data.li_attr.Mask == 0 ? -1 : data.li_attr.Mask);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_3_OCULTAR_CHECKBOX").prop('checked', (data.li_attr.Hide == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_3_NOMEMACRO").val(data.li_attr.MacroName);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_3_MACRO_CHECKBOX").prop('checked', (data.li_attr.MacroOnly == "S" ? true : false));
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_3_SOMENTESQL_CHECKBOX").prop('checked', (data.li_attr.SqlOnly == "S" ? true : false));
    }

    var fillFormCalculated = function (data) {
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_4_EXPRESSAO").val(data.li_attr.Formula);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_4_FORMATONUMEROselect").val(data.li_attr.Mask == 0 ? -1 : data.li_attr.Mask);
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_TABS_4_OCULTAR_CHECKBOX").prop('checked', (data.li_attr.Hide == "S" ? true : false));
    }

    var initCubeFieldsTree = function () {
        if (fieldsCubeNode.length == 0)
            fieldsCubeNode = [''];

        $('.loading').hide();
        $(fieldsTreeCube).on('changed.jstree', function (e, data) {
            if (data.action == "select_node") {
                $('#btnDeletarNo').show();
                selectTabFillGeneralInputs(data.instance.get_node(data.selected));
            }            
        }).jstree({
            "core": {                    
                "multiple": false,         
                "animation": 100,          
                "check_callback": true, 
                "themes": {
                    "variant": "medium",
                    "dots": false
                },

                "data": fieldsCubeNode
            },
            "plugins": [
                "dnd",
                "changed"
            ]
            });
        $(fieldsTreeCube).on("move_node.jstree", function (e, data) {
            data.node.li_attr.ParentField = data.parent;
            var objIndex = fieldsCube.Fields.findIndex(fieldInCube => fieldInCube.Name == data.node.li_attr.id);
            fieldsCube.Fields[objIndex] = data.node.li_attr;

        });
        $(fieldsTreeCube).on("copy_node.jstree", async function (e, param) {
            var json = param.node.li_attr;
            json.ParentField = $(`li[id="${param.old_parent}"]`).attr("fieldname");
            delete json["id"];
            await fetch(Page.getApplicationPath() + `api/desktopcube/createcubefield`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(json),
            }).then((response) => response.json())
                .then((data) => {
                $('.loading').show();
                var objIndex = fieldsCube.Fields.findIndex(campo => campo.Name == data.Name);
                if (objIndex == -1) {
                    param.node.li_attr = data;
                    fieldsCube.Fields[objIndex] = data.li_attr;
                    if(param.parent != '#')
                        data.ParentField = param.parent;

                    fieldsCube.Fields.push(data);
                    fieldsCubeNode = buildCubeData(fieldsCube);
                    buildChildrenCubeData();
                    $(fieldsTreeCube).jstree(true).settings.core.data = fieldsCubeNode;
                    $(fieldsTreeCube).jstree(true).refresh();
                    $('.loading').hide();
                }
                else {
                    $(fieldsTreeCube).jstree(true).refresh();
                    var message = "Não é possível adicionar 2 vezes o mesmo campo no cubo!";
                    showMessageBox(message, true);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        });
    };
    var showMessageBox = function (data, error) {
        $('#saveCubeMessageDiv').show();
        if (error) {
            $('.loading').hide();
            $('#saveCubeMessageDiv').removeClass("alert-success").addClass("alert-danger");
            $('#saveCubeMessage').text(data);
            setTimeout(() => {
                $('#saveCubeMessageDiv').hide();
            }, 5000);
        } else {
            $('.loading').hide();
            $('#saveCubeMessageDiv').removeClass("alert-danger").addClass("alert-success");
            $('#saveCubeMessage').text(data);
            setTimeout(() => {
                $('#saveCubeMessageDiv').hide();
            }, 5000);

        }
    }
    var saveCube = async function (data) {
        $('.loading').show();
        await fetch(Page.getApplicationPath() + `api/desktopcube/savedesktopcubeFields/?handle=${paramRequest.cb}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(fieldsCube),
        }).then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    showMessageBox(data.error, true);
                }
                else {
                    showMessageBox(data, false);
                }
            })
            .catch((error) => {
                console.log("Error:", error);
            });
    }

    var updateCubeArray = function (data) {
        updateFieldsCube(data);
    }

    var saveChangesField = function () {
        var selectedNode = $(fieldsTreeCube).jstree('get_selected', true)[0];
        if (selectedNode != undefined)
            updateCubeArray(selectedNode);
    }

    var addCalculatedField = function () {
        var parameter = $('.fieldsTreeCube .jstree-node').length + 1;
        var request = $.get(Page.getApplicationPath() + `api/desktopcube/createcalculatedfield?index=${parameter}`);
        request.done(function (data) {
            fieldsCube.Fields.push(data);
            fieldsCubeNode = buildCubeData({ 'Fields': [data] });
            $(fieldsTreeCube).jstree(true).create_node(null, fieldsCubeNode[0], "last");

        });
        request.fail(function (msg) {
            console.log("Falha na chamada de api/AsyncProcesses" + msg);
        });
    };

    var addCounterField = function() {
        var request = $.get(Page.getApplicationPath() + `api/desktopcube/createrecordcounter?tableName=${paramRequest.table}`);
        request.done(function (data) {
            fieldsCube.Fields.push(data);
            fieldsCubeNode = buildCubeData({ 'Fields': [data] });
            $(fieldsTreeCube).jstree(true).create_node(null, fieldsCubeNode[0], "last");

        });
        request.fail(function (msg) {
            console.log("Falha na chamada de api/AsyncProcesses" + msg);
        });
    };
    
    var initTree = async function (data) {
        initMainFieldsTableTree(paramRequest);
        await getDesktopCubeFieldsRequest(paramRequest);
    }

    var initMainFieldsTableTree = async function (param) {
        $(fieldsTreeMainTable).jstree({
            "core": {
                "multiple": false,
                "data": {
                    'url': Page.getApplicationPath() + `api/desktopcube/gettablefields`,
                    'data': function (node) {
                        if (node.li_attr != undefined && node.li_attr.ColumnClass == 6) {
                            return { 'handle': node.li_attr.LookupTableHandle, 'previousFormula': node.li_attr.Formula };
                        }
                        return { 'handle': param.handle, 'previousFormula': ''};
                    }
                }
            },
            "plugins": ["contextmenu", "dnd", "changed"]
        });
    }


    var init = function () {
        $('#btnDeletarNo').hide();
        $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_NOMECAMPO").attr('readonly', true);

        $("#btnAddCounterField").on("click", function (event) {
            event.preventDefault();
            addCounterField();
        });
        $("#btnAddCalculatedField").on("click", function (event) {
            event.preventDefault();
            addCalculatedField();
        });
        $(document).on("click", ".btn-save", function (event) {
            event.preventDefault();
            saveChangesField();
            setTimeout(function () {
                $("#ctl00_Main_FIELDSCUBE_PageControl_GERAL_GERAL_NOMECAMPO").attr('readonly', true);
            }, 1000);
        });
        $("#btnSaveCube").on("click", function (event) {
            event.preventDefault();
            saveCube();
        });
        $("#btnDeletarNo").on("click", function (event) {
            event.preventDefault();
            var instance = $(fieldsTreeCube).jstree(true);
            var objIndex = fieldsCube.Fields.findIndex(fieldInCube => fieldInCube.Name == instance.get_selected());
            fieldsCube.Fields.splice(objIndex);
            instance.delete_node(instance.get_selected());
            $('#aspnetForm')[0].reset();
            $('#btnDeletarNo').hide();
        });

        initTree(paramRequest["tb"]);
    };

    return {
        init: init,
    }

})();

export default FieldEditorCube;
